import React, { useMemo } from "react";
import { useHistory, useParams } from "react-router";
import { Row, Col } from "antd";
import CustomButton from "../../../common/Buttons/CustomButton";
import commonStyles from "../ModeSelection/ModeSelection.module.scss";
import VehicleCard from "../../Shared/VehicleCard/VehicleCard";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import { ILosCharges } from "../../../types/TripTypes";
import { backArrowIcon } from "../../../assets/images";

interface IParams {
  ride: string;
  serviceUserId: string;
}
type Props = {
  losCharges: ILosCharges;
};
const LevelOfService: React.FC<Props> = ({ losCharges }) => {
  const history = useHistory();
  const { ride, serviceUserId } = useParams<IParams>();

  const { serviceDataCtx } = useTripsCtx();
  const [serviceData] = serviceDataCtx;

  const memoizedUser = useMemo(() => {
    const serviceUser = serviceData?.find(
      (data: { personId: number }) => data.personId === Number(serviceUserId)
    );
    return serviceUser;
  }, [serviceUserId, serviceData]);

  const handleBack = () => history.goBack();

  return (
    <div className={commonStyles.selectionContainer}>
      <Row align="middle">
        <Col
          xs={{ offset: 1 }}
          sm={{ offset: 1 }}
          md={{ offset: 1 }}
          lg={{ offset: 4 }}
        >
          <CustomButton
            text="Back"
            handlerFunction={handleBack}
            type="link"
            icon={backArrowIcon}
            className="backBtn"
          />
        </Col>
      </Row>
      <Row justify="center">
        <Col
          xs={{ span: 23, offset: 1 }}
          sm={{ span: 23, offset: 1 }}
          md={{ span: 23, offset: 1 }}
          lg={{ span: 24, offset: 0 }}
          className={`${commonStyles.transportationText} ${commonStyles.centerTextOnLg}`}
        >
          TRANSPORTATION SETUP
        </Col>
      </Row>

      <Row justify="center">
        <Col
          xs={{ span: 23, offset: 1 }}
          sm={{ span: 23, offset: 1 }}
          md={{ span: 23, offset: 1 }}
          lg={{ span: 24, offset: 0 }}
          className={`${commonStyles.selectRideText} ${commonStyles.centerTextOnLg}`}
        >
          Select a level of service
        </Col>
      </Row>

      <div className={commonStyles.mediaContainer}>
        {ride === "Standard" && (
          <>
            <VehicleCard
              title="Curb-to-Curb"
              description={`${memoizedUser?.firstName} will be picked up and dropped off curbside.`}
              isFirstItem={true}
            />
            <VehicleCard
              title="Door-to-Door"
              description={`${memoizedUser?.firstName} will be picked up and dropped off at the front door.`}
              extraFee={(losCharges?.losDoorToDoor)}
              isFirstItem={false}
            />
            <VehicleCard
              title="Person-to-Person"
              description={`${memoizedUser?.firstName} will be escorted by a driver at the pickup and dropoff locations.`}
              extraFee={(losCharges?.losPersonToPerson)}
              isFirstItem={false}
            />
          </>
        )}

        {ride === "WAV" && (
          <>
            <VehicleCard
              title="Door-to-Door"
              description={`${memoizedUser?.firstName} will be picked up and dropped off at the front door.`}
              isFirstItem={true}
            />
            <VehicleCard
              title="Person-to-Person"
              description={`${memoizedUser?.firstName} will be escorted by a driver at the pickup and dropoff locations.`}
              extraFee={(losCharges?.losPersonToPersonWav)}
              isFirstItem={false}
            />
          </>
        )}
      </div>
    </div>
  );
};
export default LevelOfService;
